var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1703_581)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    fill: "#FF9900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1703_581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 105,
    height: 105
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7085,
    y: 29.7084,
    width: 95.5833,
    height: 95.5833,
    fill: "white",
    stroke: "#FF9900",
    strokeWidth: 7.75003
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1703_581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5 77.201C78.8716 75.3673 80.6216 73.85 82.6312 72.7521C84.6408 71.6542 86.863 71.0013 89.1471 70.8377C91.4312 70.6741 93.7238 71.0037 95.8693 71.804C98.0149 72.6044 99.9632 73.8568 101.582 75.4763L111.164 85.0581C114.073 88.07 115.683 92.1039 115.646 96.2911C115.61 100.478 113.93 104.484 110.969 107.445C108.008 110.405 104.003 112.085 99.8159 112.121C95.6288 112.158 91.5948 110.548 88.5829 107.639L83.0894 102.177",
    stroke: "white",
    strokeWidth: 7.75003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4999 77.2012C76.1283 79.0349 74.3783 80.5522 72.3687 81.6501C70.3591 82.7481 68.1369 83.401 65.8528 83.5645C63.5687 83.7281 61.2761 83.3986 59.1306 82.5982C56.985 81.7979 55.0367 80.5455 53.4178 78.9259L43.836 69.3442C40.927 66.3323 39.3174 62.2983 39.3538 58.1111C39.3901 53.9239 41.0696 49.9186 44.0305 46.9577C46.9914 43.9968 50.9968 42.3173 55.184 42.2809C59.3712 42.2445 63.4051 43.8542 66.417 46.7631L71.8786 52.2247",
    stroke: "white",
    strokeWidth: 7.75003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4661 68.1673L86.5336 86.2348",
    stroke: "white",
    strokeWidth: 7.75003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1703_581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92e5c70c7f5a43910c315094b273e94f.svg";
export { ForwardRef as ReactComponent };